export type LocaleCode = 'en' | 'fr' | 'es' | 'de' | 'zh' | 'ja';

export const SUPPORTED_LOCALES: readonly LocaleCode[] = ['en', 'fr', 'es', 'de', 'zh', 'ja'];

export const LOCALE_LABELS: Record<LocaleCode, string> = {
  en: 'English',
  fr: 'Français',
  es: 'Español',
  de: 'Deutsch',
  zh: '中文',
  ja: '日本語',
};

export interface Messages {
  brand: {
    tagline: string;
  };
  status: {
    label: string;
    awaitingInputs: string;
    ready: string;
    fault: string;
    allInputsLoaded: string;
    requiredInputs: string;
  };
  setup: {
    intro: string;
    parametersHeader: string;
    horizonDays: string;
    purchaseLeadDays: string;
    productionLeadDays: string;
    safetyStockPercent: string;
    runEngine: string;
    fault: string;
  };
  slots: {
    bom: string;
    inventory: string;
    sales: string;
    mfg: string;
    purchase: string;
    parts: string;
    dropHint: string;
    parsing: string;
    rows: string;
    failed: string;
    mapColumns: string;
  };
  mapping: {
    header: string;
    ready: string;
    missing: string;
    confirm: string;
  };
  processing: {
    expandingBom: string;
    seedingDemand: string;
    simulating: string;
    running: string;
    cancel: string;
  };
  results: {
    orders: string;
    newRun: string;
    downloadCsv: string;
    nothingToBuy: string;
    colOrderBy: string;
    colSku: string;
    colDescription: string;
    colHave: string;
    colNeed: string;
    colUom: string;
    colNeedBy: string;
    colDriving: string;
  };
  warnings: {
    quarantined: string;
    clear: string;
  };
  locale: {
    chooseLanguage: string;
  };
  toasts: {
    simFailed: string;
    simNoPurchases: string;
    simRecommendationCount: string;
    mapAllFirst: string;
    dismiss: string;
  };
  help: {
    open: string;
    title: string;
    intro: string;
    filesHeader: string;
    requiredMark: string;
    requiredNote: string;
    outputHeader: string;
    outputBody: string;
    tipsHeader: string;
    tipGreenfield: string;
    tipQuarantine: string;
    tipPrivacy: string;
    gotIt: string;
    close: string;
  };
  slotHelp: {
    requiredColumns: string;
    optionalColumns: string;
    bom: string;
    inventory: string;
    sales: string;
    mfg: string;
    purchase: string;
    parts: string;
  };
}
